export default {"src":"/_next/static/media/TSLQ.bfd49ad4.svg","height":18,"width":18};